import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'




// CREATE A FORM
const submit = (payload) =>  client.post('forms/types', payload);
export const useCreateForm = () => useMutation(['createForm'],(payload) => submit(payload))

// CREATE A COMMENT
const comment = (payload) => client.post('forms/comments', payload);
export const useCreateComment = () => useMutation(['createComment'],(payload) => comment(payload))

const postAttachments = (formId, officerId, files, config = {}) => {
  const fd = new FormData();
  fd.set("FormId", formId);       // must match your [FromForm] property names
  fd.set("OfficerId", officerId);
  // append each file under the SAME key ("Documents") for model binding to a collection
  for (const file of files) fd.append("Documents", file);

  return client.post("forms/attachments", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    ...config, // e.g., { onUploadProgress }
  });
};

export const usePostAttachments = () =>
  useMutation({
    mutationFn: ({ formId, officerId, files, config }) =>
      postAttachments(formId, officerId, files, config),
    // Optional: onSuccess to refetch the form or attachments list
    // onSuccess: () => queryClient.invalidateQueries(['engaged', ...]),
  });
